import { render, staticRenderFns } from "./AIAvatarSelectionPanel.vue?vue&type=template&id=481b5a1c&scoped=true"
import script from "./AIAvatarSelectionPanel.vue?vue&type=script&lang=ts"
export * from "./AIAvatarSelectionPanel.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarSelectionPanel.vue?vue&type=style&index=0&id=481b5a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b5a1c",
  null
  
)

export default component.exports